import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b7e4edfa"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "p-panel-title" };
const _hoisted_2 = { class: "flex justify-content-center flex-wrap gap-3 mt-3" };
import useImportRecordsStore from '@/store/importRecords.store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReviewRecord',
    props: {
        record: null
    },
    setup(__props) {
        const props = __props;
        const importRecordsStore = useImportRecordsStore();
        const records = [props.record];
        return (_ctx, _cache) => {
            const _component_Column = _resolveComponent("Column");
            const _component_DataTable = _resolveComponent("DataTable");
            const _component_Fieldset = _resolveComponent("Fieldset");
            const _component_Button = _resolveComponent("Button");
            const _component_Panel = _resolveComponent("Panel");
            return (_openBlock(), _createBlock(_component_Panel, {
                toggleable: "",
                class: "mb-2"
            }, {
                header: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, "Line " + _toDisplayString(props.record.rowNumber), 1)
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_DataTable, {
                        value: records,
                        class: "p-datatable-sm mb-3",
                        responsiveLayout: "scroll"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_Column, {
                                field: "transactionCode",
                                header: "Trans Code"
                            }),
                            _createVNode(_component_Column, {
                                field: "receivingDfiid",
                                header: "Rec DFI ID"
                            }),
                            _createVNode(_component_Column, {
                                field: "checkDigit",
                                header: "Check Digit"
                            }),
                            _createVNode(_component_Column, {
                                field: "dfiaccountNumber",
                                header: "DF Acct #"
                            }),
                            _createVNode(_component_Column, {
                                field: "totalAmount",
                                header: "Amount"
                            }),
                            _createVNode(_component_Column, {
                                field: "identificationNumber",
                                header: "Individual ID #"
                            }),
                            _createVNode(_component_Column, {
                                field: "individualName",
                                header: "Name"
                            }),
                            _createVNode(_component_Column, {
                                field: "companyName",
                                header: "CompanyName"
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_Fieldset, { legend: "Rule Violations" }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.record.violationMessages, (message) => {
                                return (_openBlock(), _createElementBlock("ul", {
                                    key: message,
                                    class: "mb-0 mt-0"
                                }, [
                                    _createElementVNode("li", null, _toDisplayString(message), 1)
                                ]));
                            }), 128))
                        ]),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        (!props.record.approved && !props.record.flaggedNewPayee)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: "Approve and Add",
                                severity: "success",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(importRecordsStore).approveRecord(props.record.id))),
                                id: "add-btn"
                            }))
                            : _createCommentVNode("", true),
                        (!props.record.approved && !props.record.flaggedNewPayee)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                label: "Approve and Ignore",
                                severity: "success",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(importRecordsStore).ignoreRecord(props.record.id))),
                                id: "ignore-btn"
                            }))
                            : _createCommentVNode("", true),
                        (props.record.approved)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 2,
                                label: "Remove Approval",
                                severity: "danger",
                                onClick: _cache[2] || (_cache[2] = ($event) => (_unref(importRecordsStore).removeRecordApproval(props.record.id))),
                                id: "remove-approval-btn"
                            }))
                            : _createCommentVNode("", true),
                        (props.record.flaggedNewPayee && !props.record.approved)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 3,
                                label: "Approve and Add New Payee",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_unref(importRecordsStore).addNewPayee(props.record.importedRecordDetailId))),
                                id: "add-payee-btn"
                            }))
                            : _createCommentVNode("", true),
                        (props.record.flaggedNewPayee && !props.record.approved)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 4,
                                label: "Approve and Ignore New Payee",
                                onClick: _cache[4] || (_cache[4] = ($event) => (_unref(importRecordsStore).ignoreNewPayee(props.record.importedRecordDetailId))),
                                id: "ignore-payee-btn"
                            }))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }));
        };
    }
});
